import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebookF,
  faYoutube,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
  const linkClass =
    'inline-flex items-center justify-center rounded-none bg-white/10 p-3 text-white transition hover:bg-white';

  return (
    <footer className="bg-brand text-white">
      <div className="section-container grid gap-4 py-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <h2 className="text-3xl font-semibold mb-2">Dr. Priya Bhave Chittawar</h2>
          <p className="text-sm text-white/80 mb-2">
            <span className="text-white">Location</span>
            <br />
            33,34,40,41 Narmadapuram Road, Chinar Fortune City, Bhopal, Madhya Pradesh 462026
          </p>
          {/* <p className="text-sm text-white/80">
            <span className="text-white">Contact</span>
            <br />
            <a className="text-white underline" href="mailto:priyabhave1@gmail.com">
              priyabhave1@gmail.com
            </a>
            <br />
            +91 789 830 1766
          </p> */}
        </div>

        <div className="md:col-span-2">
          <h5 className="text-lg font-semibold">Connect</h5>
          <div className="mt-3 flex flex-wrap gap-3 text-sm">
            <a
              className={linkClass}
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/drpriyabhavechittawar/"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
              <span className="sr-only">Instagram</span>
            </a>
            <a
              className={linkClass}
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/drpriyabhave/"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
              <span className="sr-only">Facebook</span>
            </a>
            <a
              className={linkClass}
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/drpriyabhavechittawar"
              aria-label="YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} />
              <span className="sr-only">YouTube</span>
            </a>
            <a
              className={linkClass}
              target="_blank"
              rel="noreferrer"
              href="https://in.linkedin.com/in/dr-priya-bhave-chittawar-419202178"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
              <span className="sr-only">LinkedIn</span>
            </a>
            <a
              className={linkClass}
              target="_blank"
              rel="noreferrer"
              href="https://drpriyabhavechittawar1.blogspot.com/"
              aria-label="Blog"
            >
              <FontAwesomeIcon icon={faGlobe} />
              <span className="sr-only">Blog</span>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-2 text-center text-sm text-white/70">
        © {new Date().getFullYear()} Dr. Priya Bhave
      </div>
    </footer>
  );
}
